.divider {
  margin-top: 16px;
  margin-bottom: 16px;
}
